/**
 * @generated SignedSource<<f32cf9876892d1fb335ab0f9ecf74e98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerNewsletterArticleArticle$data = {
  readonly headline: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbNewsletterArticleArticle" | "issuesNewsletterArticleArticle" | "widgetNewsletterArticleArticle">;
  readonly " $fragmentType": "headerNewsletterArticleArticle";
};
export type headerNewsletterArticleArticle$key = {
  readonly " $data"?: headerNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerNewsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "breadcrumbNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "widgetNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "1160fa66fc28ea95820c0acf6f843b74";

export default node;
